<template>
  <form v-scroll-to-error>
    <div>
      <module-title
        v-if="![3710].includes(Number(event.id))"
        :color="event.id === '1714' ? '#000' : secondaryColor"
        :title="styles.title || $t('registration', 'Registration')"
      />
    </div>
    <div>
      <div v-if="styles.titleDescription" class="title-description mb-32 pl-0">
        {{ styles.titleDescription }}
      </div>
      <div v-else class="title-description mb-32 pl-0">
        {{ $t('attendeeDataDescription') }}
      </div>
    </div>
    <div>
      <accreditation-form
        :event="event"
        :styles="styles.form"
        :fields="schema.attendeeFields"
        :category="category"
        :initial-values="initialValues"
        :vs="$v"
        @values="form = $event"
      />
    </div>
    <div class="attendee-actions">
      <main-button
        class="back-btn"
        flat
        :text="styles.goBack || $t('back')"
        :color="getThemeStyle(event.coverImagePrimaryColor, null, 'primary')"
        @click="$emit('back')"
      />
      <div class="buttons">
        <main-button
          v-if="!event.extraModules.workshops && !['952', '2444'].includes(event.id)"
          class="submit-btn"
          depressed
          :text="styles.submit || $t('send')"
          :color="getThemeStyle(event.coverImagePrimaryColor, null, 'primary')"
          @click="submitForm(true)"
        />
        <main-button
          v-if="event.extraModules.workshops && !['952', '2444'].includes(event.id)"
          class="submit-btn"
          flat
          :text="styles.submit || $t('send')"
          :color="getThemeStyle(event.coverImagePrimaryColor, null, 'primary')"
          @click="submitForm(true)"
        />
        <main-button
          v-if="event.extraModules.workshops"
          class="continue-btn"
          depressed
          :color="getThemeStyle(event.coverImagePrimaryColor, null, 'primary')"
          @click="submitForm()"
        >
          {{ styles.continue || $t('continueToWorkshops', 'Continue to workshops') }}
          <span class="material-icons"> arrow_forward </span>
        </main-button>
      </div>
    </div>
  </form>
</template>

<script>
import ModuleTitle from './../../shared/module-title.vue'
import AccreditationForm from './../accreditation-form.vue'
import { submitGuard } from './../../../utils'

import { maxLength, requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'attendee-data',
  components: {
    AccreditationForm,
    ModuleTitle,
  },
  props: {
    event: {
      type: Object,
      default: null,
    },
    category: {
      type: Object,
      default: null,
    },
    styles: {
      type: Object,
      default: () => ({}),
    },
    schema: {
      type: Object,
      default: () => ({}),
    },
    initialValues: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {},
      secondaryColor: '#FF4C00',
      zkmColor: '#333333',
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  validations() {
    if (this.event && this.event.id == 2444) {
      this.schema.validationSchema['Tvrtka/ustanova'].maxLength = maxLength(32)
    }
    return {
      form: {
        category: {
          required: requiredIf(() => this.event.extraModules.categoriesAndZones && !this.category),
        },
        ...this.schema.validationSchema,
      },
    }
  },
  methods: {
    async submitForm(skipNext = false) {
      await submitGuard(this, () => {
        this.$emit(skipNext ? 'submit' : 'next', this.form)
      })
    },
  },
}
</script>

<style scoped>
.attendee-actions {
  display: flex;
  justify-content: space-between;
}

@media screen and (max-width: 800px) {
  .attendee-actions {
    flex-direction: column-reverse;
  }
}
</style>
